module.exports = __webpack_public_path__ + "d362614f566a715024c760a2645adfdd.svg";